import { render, staticRenderFns } from "./FieldWorkplaceMaterialInfo.vue?vue&type=template&id=1858891b&scoped=true"
import script from "./FieldWorkplaceMaterialInfo.vue?vue&type=script&lang=js"
export * from "./FieldWorkplaceMaterialInfo.vue?vue&type=script&lang=js"
import style0 from "./FieldWorkplaceMaterialInfo.vue?vue&type=style&index=0&id=1858891b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1858891b",
  null
  
)

export default component.exports